"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ConnectedChildrenNotFound extends client_library_1.ExtendableError {
    constructor() {
        super('Connected children not found');
    }
}
exports.default = ConnectedChildrenNotFound;
//# sourceMappingURL=ConnectedChildrenNotFound.js.map